module.exports = __webpack_public_path__ + "media/images/projects/3-header-b36d05811beda7ad3ff6ae3a87989cb5.jpg";